import React, { useState } from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    Image
} from 'react-native-web';
import PropTypes from 'prop-types';

// Configs
import GLOBAL from '../configs/config_global';

export function SectionTitle({ title, description, hideDescription, style = {} }) {
    // region Local State
    const [showDescription, setShowDescription] = useState(false);
    // endregion

    // region MAIN RENDER
    return(
        <View style={[{ width: '100%', backgroundColor: GLOBAL.COLOR.BACKGROUND_GREY, paddingHorizontal: 24, paddingBottom: 16, paddingTop: 24 }].concat(style)}>
            <View style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch' }}>
                <Text style={{ fontWeight: 'bold', color: GLOBAL.COLOR.BASIC.BLACK_TWO, fontSize: 22 }}>
                    {title}
                </Text>

                {/* Help Button */}
                {
                    hideDescription &&
                    <TouchableOpacity
                        onPress={() => setShowDescription(!showDescription)}
                        style={{ alignItems: 'center', justifyContent: 'center', marginLeft: 8 }}>
                        <Image
                            source={require('../images/iconLineInfo.png')}
                            style={{ width: 24, height: 24, tintColor: GLOBAL.COLOR.BASIC.NEUTRAL_LIGHT_GREY }}
                        />
                    </TouchableOpacity>
                }
            </View>

            {
                (description?.trim() && showDescription) ?
                    <Text style={{ fontSize: 18, fontWeight: '400', color: GLOBAL.COLOR.BASIC.NEUTRAL_GREY, marginTop: 8, lineHeight: 22 }}>
                        {description}
                    </Text>
                    :
                    null
            }
        </View>
    );
    // endregion
}

// region Props
SectionTitle.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    hideDescription: PropTypes.bool
};

SectionTitle.defaultProps = {
    title: 'Title',
    description: '',
    hideDescription: false
};
// endregion
